import { combineReducers } from "redux";

const UserReducer =(state={name:"kawish",user:[]},action)=>{

    switch(action.type)
    {
        case 'ADD_DATA':
            {
                const newArr=state.user
                newArr.push(action.payload)
                return{...state,user:newArr}

            }
        case 'DELETE_DATA':
                
                  const newArray= state.user.filter((i,index) => index !== action.payload)
                  return{...state,user:newArray};
        case 'UPDATE STATUS':
            const { task, status } = action.payload;
            const updatedTasks = state.user.map((newStat) =>
            newStat.task === task ? { ...newStat, status } : newStat
                );
                return { ...state, user: updatedTasks };         
                   
        default:return state
    }

}

export default combineReducers({UserReducer})